import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=318d7ed8&"
import script from "./ProductSettings.vue?vue&type=script&lang=ts&"
export * from "./ProductSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports